import produce from "immer";
import moment from "moment";
import {
  COMMENT_LIST_REQUEST,
  COMMENT_LIST_SUCCESS,
  COMMENT_LIST_FAILURE,
  COMMENT_CREATE_SUCCESS,
  RECORDING_BULK_UPDATE_SUCCESS,
} from "../actions/types";

const commentsInitState = {
  ids: [],
  hash: {},
  loading: false,
  cachedAt: null,
  error: {},
};

export const comments = (state = commentsInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // ---------------- REQUEST ----------------
      case COMMENT_LIST_REQUEST:
        draft.loading = true;
        break;
      // ---------------- SUCCESS ----------------
      case COMMENT_LIST_SUCCESS:
        draft.ids = [];
        draft.hash = {};
        draft.loading = false;
        action.comments.forEach((comment) => {
          draft.ids.push(comment.id);
          draft.hash[comment.id] = comment;
        });
        draft.cachedAt = moment();
        break;
      case RECORDING_BULK_UPDATE_SUCCESS:
        action.comments.forEach((comment) => {
          draft.ids.push(comment.id);
          draft.hash[comment.id] = comment;
        });
        break;
      case COMMENT_CREATE_SUCCESS:
        draft.ids.push(action.comment.id);
        draft.hash[action.comment.id] = action.comment;
        break;
      // ---------------- FAILURE ----------------
      case COMMENT_LIST_FAILURE:
        draft.loading = false;
        draft.error = action.error;
        break;
      default:
    }
  });
